import { FC } from "react";

/**
 * Simple pass-through guard for iframe routes.
 * Authentication is handled by the layout component via popup.
 */
export const IframeAuthenticationGuard = ({ component }: { component: FC }) => {
  const Component = component;
  return <Component />;
};
